export const NOTIFICATION_NAME = 'tradeProgramAnnouncement';
export const MODAL_ID = 'tradeProgramAnnouncementModal';
export const NUM_TIMES_TO_SHOW = 2;
